// Free WhatsApp sharing via the wa.me link — no API, no cost.
// Opens WhatsApp with the message pre-filled; the person taps "send".

export function shareWhatsApp(text, phone) {
  const base = phone
    ? 'https://wa.me/' + String(phone).replace(/\D/g, '')
    : 'https://wa.me/';
  window.open(base + '?text=' + encodeURIComponent(text), '_blank');
}
